import React from 'react';
import { ArrowRight } from 'react-feather';
import { OG_IMAGE } from '../constants/assets';
import { Footer } from './Footer';
import { Header } from './Header';
import { PageMeta } from './PageMeta';
interface WorkPageProps {
  onNavigate: (page: string) => void;
}
export function WorkPage({
  onNavigate
}: WorkPageProps) {
  return <div className="relative flex min-h-screen flex-col bg-white text-[#111111]" data-id="element-201">
      <PageMeta title="Sixteen years making complex systems usable." description="From problem to shipped interface, at the level of craft the work demands." url="https://mintextract.design/work" ogImage={OG_IMAGE} data-id="element-202" />

      <Header actionLabel="Home" actionHref="/" onAction={() => onNavigate('home')} data-id="element-203" />

      <main className="relative z-10 flex w-full flex-1 items-center" data-id="element-204">
        <div className="w-full px-8 py-12 md:py-16" data-id="element-205">
          <div className="mx-auto max-w-[1200px]" data-id="element-206">
            <h1 className="mb-8 text-fluid-3xl font-bold uppercase tracking-tight animate-fadeIn md:text-[clamp(4.209rem,5vw,5.61rem)]" data-id="element-207">
              Sixteen years making complex systems usable.
            </h1>

            <div className="flex flex-col gap-3 text-[1.1rem] text-[#7A8290] animate-fadeIn md:text-fluid-lg md:text-[clamp(1.333rem,2vw,1.777rem)]" data-id="element-208">
              <p data-id="element-209">From the rules underneath to the screen on top.</p>
              <p data-id="element-210">My work:</p>
              <ul className="flex flex-col items-start gap-3" data-id="element-211">
                <li className="group block transition-all duration-300 hover:translate-x-2" data-id="element-212">
                  <a href="/work/required-actions?from=work" onClick={event => {
                  event.preventDefault();
                  onNavigate('work/required-actions?from=work');
                }} className="inline-flex items-center gap-2 rounded-sm text-[#7A8290] transition-colors duration-300 hover:text-[#111111] focus:outline-none focus:ring-2 focus:ring-[#111111]/20 focus:ring-offset-1 focus:ring-offset-white" aria-label="View the Required Actions case study" data-id="element-213">
                    Turning rules into a workflow brokers can clear
                    <ArrowRight size={18} strokeWidth={2} className="shrink-0" aria-hidden="true" data-id="element-214" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-215" />
    </div>;
}